import useElement from "backend/hooks/elements/useElement";
import InitiativeReport from "components/reports/InitiativeReport";
import ToolbarWithButton from "components/toolbars/ToolbarWithButton";
import ExportFileSelectionPopUp from "design/components/popups/ExportFileSelectionPopup";
import ToolbarTitle from "design/components/texts/ToolbarTitle";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import React, { useState } from "react";

type Props = {};

const InitiativeToolbar = (props: Props) => {
  const ctx = useAppContext();
  const { data } = useElement(ctx.elementId);
  const [anchorEl, setAnchorEl] = useState<
    (EventTarget & HTMLButtonElement) | null
  >(null);
  const [fileType, setFileType] = useState<string | null>();
  const [isExporting, setIsExporting] = useState<boolean>(false);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleSelectFile = (type: string) => {
    setFileType(type);
    setAnchorEl(null);
    setIsExporting(true);
  };

  const metadata = data?.JS_ATTR ? JSON.parse(data?.JS_ATTR) : "";
  const initiativeName = metadata
    ? metadata["Localized-Text-Attributes"][ctx.language]?.Name
    : data?.name;

  return (
    <>
      <ToolbarWithButton onClick={handleClick}>
        <ToolbarTitle>{initiativeName}</ToolbarTitle>
      </ToolbarWithButton>
      {data ? (
        <>
          <ExportFileSelectionPopUp
            onClose={() => {
              setAnchorEl(null);
            }}
            handleClick={handleSelectFile}
            anchorEl={anchorEl}
          />
        </>
      ) : null}

      {isExporting && data && fileType ? (
        <InitiativeReport
          item={data}
          filetype={fileType!}
          onClose={() => {
            setIsExporting(false);
          }}
        />
      ) : null}
    </>
  );
};

export default InitiativeToolbar;
